import React, { Component } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { dateFormatWithTime, dayAgo } from "../../helper";
import { PATHS } from "../../constant";
import { get } from "lodash";
import { AgendaCardInfo } from "./agendaCardInfo";
import PermissionHOC from "../PermissionHOC";
import { getAgendaStakeHolderAction } from "../../actions/mom.action";
import { ReadMore } from "../reusableComponent/readMore";
import {
  getLocalstorage,
  dateFormat,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  getAgendaTagsColor
} from "../../helper";
import ChairedBy from "../../assets/created-by.svg";

class AgendaCard extends Component {
  state = {
    openSummary: false
  };

  onToggleSummary = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openSummary: !prevState.openSummary }));
  };

  getAgendaStackeHolder = async () => {
    const { agendaListDto } = this.props;
    return await getAgendaStakeHolderAction(undefined, agendaListDto);
  };

  render() {
    const { openSummary } = this.state;
    const { onToggleSummary } = this;
    const { agendaDetails } = this.props;
    const URL =
      agendaDetails && agendaDetails.meetingStatus === "DRAFT"
        ? PATHS.CREATE_AGENDA
        : PATHS.AGENDA_DETAILS;
    const user = getLocalstorage("user");
    return (
      <React.Fragment>
        {openSummary ? (
          <AgendaCardInfo
            agendaDetails={agendaDetails}
            onClose={onToggleSummary}
          />
        ) : (
          <React.Fragment />
        )}
        <Link
          to={{
            pathname: URL,
            search: `?agendaId=${get(agendaDetails, "id", "NA")}`,
            state: {
              agendaId: agendaDetails && agendaDetails.id
            }
          }}
        >
          <Container fluid className="agenda-card">
            <Row className="agenda-row">
              <Col className="agenda agenda-col-1">
                <div className="agenda-cards-alignment">
                  <div>
                    <div className="agenda-details mb-2 align-items-center">
                      <div className="agenda-list-title">
                        AGENDA
                        <span className="agenda-id">
                          #{agendaDetails && agendaDetails.id}
                        </span>
                        |
                        <span className="agenda-total">
                          {agendaDetails &&
                            get(agendaDetails, "projectCount", null)}{" "}
                          Project(s) &{" "}
                          {agendaDetails && agendaDetails.issueCount} Issue(s)
                        </span>
                      </div>

                      <div>
                        {(get(user, "groupCategory") == "PMG" ||
                          get(user, "groupCategory") == "STATE_PMG" ||
                          get(user, "groupCategory") == "CENTRAL" ||
                          get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
                          get(user, "groupCategory") == "STATE") && (
                          <div
                            className={`${getAgendaTagsColor(
                              agendaDetails.meetingStatus
                            )} ${
                              agendaDetails.meetingStatus === "DRAFT"
                                ? "draft-agenda-btn"
                                : ""
                            } agenda-stage`}
                          >
                            <div
                              className={`agenda-stage-background ${
                                agendaDetails.meetingStatus === "DRAFT"
                                  ? "draft-agenda-text"
                                  : ""
                              }`}
                            >
                              {agendaDetails.meetingStatus}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="agenda-details">
                      <div className="agenda-list-title">
                        <h3
                          className="agenda-title mb-4"
                          style={{
                            paddingTop: agendaDetails.agendaName.match(
                              /[\u0900-\u097F]/
                            )
                              ? "4px"
                              : ""
                          }}
                        >
                          {agendaDetails && agendaDetails.agendaName}
                        </h3>
                      </div>
                    </div>
                    <div className="flex-style">
                      <div className="meeting-info meeting-when flex-width">
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details">When</b>
                          {getDayOfTheGivenDate(agendaDetails.meetingDate) +
                            ", " +
                            dateFormat(get(agendaDetails, "meetingDate"))}
                          <br />
                          {agendaDetails.meetingTimeFrom !== null &&
                            agendaDetails.meetingTimeFrom !== 0 &&
                            getTimeOfTheGivenDate(
                              agendaDetails.meetingTimeFrom
                            )}
                        </span>
                      </div>
                      <div className="meeting-info meeting-venue flex-width">
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details">Venue</b>
                          {agendaDetails && agendaDetails.venueName}
                        </span>
                      </div>
                    </div>

                    <div className="flex-style">
                      <div className="meeting-info meeting-type flex-width">
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details">
                            Meeting Type
                          </b>
                          {(agendaDetails && agendaDetails.meetingType) || "NA"}
                        </span>
                      </div>
                      <div className="flex-width d-flex agenda-card-chairedby">
                        <span>
                          <Image src={ChairedBy} />
                        </span>
                        <div>
                          <span className="info-in-agenda-detail">
                            <b className="heading-in-agenda-details">
                              Chaired By
                            </b>{" "}
                            <br />
                            {agendaDetails && agendaDetails.meetingChairedBy}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="flex-style summary">
                      <a
                        onClick={e => {
                          onToggleSummary(e);
                        }}
                      >
                        Agenda Summary
                        <hr className="agenda-summary-line" />
                      </a>
                    </div>

                    <div className="agenda-created-on">
                      Created By{" "}
                      <span>{agendaDetails.meetingCreatedBy} on </span>
                      <span>
                        {getDayOfTheGivenDate(agendaDetails.agendaCreatedOn) +
                          ", " +
                          dateFormat(agendaDetails.agendaCreatedOn) +
                          ", " +
                          getTimeOfTheGivenDate(agendaDetails.agendaCreatedOn)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Link>
      </React.Fragment>
    );
  }
}

export default PermissionHOC(AgendaCard);
